<template>
<div class="w-100 h-100 p-relative d-flex align-items-center">
  <div class="container">
    <template v-if="isMobile().phone">
      <div class="row no-gutters">
        <div class="col-6" v-for="i in 6" :key="i" @click="showModal(i)">
          <RollImage ref="rollImageMobile" :isShown="isShown" :directoryNo="''+i" :rotationLv="rotationLv" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-md-6 col-lg-4" v-for="i in 6" :key="i" @click="showModal(i)">
          <RollImage ref="rollImagePc" :isShown="isShown" :directoryNo="''+i" :rotationLv="isMobile().any? rotationLv: rotationLvPc" />
        </div>
      </div>
    </template>
    <div class="py-5 py-md-0">
    </div>
  </div><!-- /.container -->
  <h2 class="right-title futura tracking-1">ART WORK</h2>
  <div class="right-item">
    <div class="tategaki font-weight-bold">
      紙とセロハンテープでつくられる生き物たち
    </div>
  </div>
  <ArtworkModal ref="artworkModal"/>
</div>
</template>

<script>
import RollImage from '@/components/RollImage'
import ArtworkModal from '@/components/ArtworkModal'
import isMobile from 'ismobilejs'

export default {
  name: 'ArtWork',
  components: {
    RollImage, ArtworkModal
  },
  props: {
    rotationLv: {
      type: String,
      default: '3'
    },
  },
  data() {
    return {
      isMobile,
      rotationLvPc: '3',
      selectedDirectoryNo: 1,
      isShown: false
    }
  },
  methods: {
    load() {
      console.log('loaded!')
    },
    showModal(index) {
      this.$refs.artworkModal.show(index)
    },
    openingEffect() {
      if (!this.isShown) {
        this.isShown = true
        // console.log('openning!!!')
        // console.log(this.$refs.rollImagePc[0])
        for (let i=0; i<6; i++) {
          if(this.$refs.rollImagePc) {
            this.$refs.rollImagePc[i].openingEffect()
          }
          if(this.$refs.rollImageMobile) {
            this.$refs.rollImageMobile[i].openingEffect()
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>